const CONFIG = {
  CRS_CONSUMER_CONSENT_SERVICE:
    'https://profile.chase.com',
};

export default CONFIG;
